import { useEffect, useRef, useState } from "react";
import "../App.css";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function BlogSection() {
  const rssUrl = process.env.REACT_APP_BLOG_URL;

  const blogSwiperRef = useRef(null);

  const [blogs, setBlogs] = useState([]);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("-");
  }

  const getBlogs = () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(rssUrl, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        var temp = JSON.parse(result);
        setBlogs(temp.items);
      });
  };

  useEffect(() => {
    getBlogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="section blogSection">
        <div className="row row90 teamContainer">
          <div className="col-sm-3"></div>
          <div className="col-sm-6 sports">
            <div className="blueSubHeading">Latest</div>
            <div className="whiteHeading">Emorya News And Blog</div>
          </div>
          <div className="col-sm-3"></div>

          <div
            className="col-sm-12 showOnDesktop"
            style={{
              textAlign: "center",
              paddingTop: 50,
            }}
          >
            {blogs.map((blog) => {
              return (
                <div
                  className="blogBox"
                  key={blog.thumbnail}
                  onClick={() => {
                    window.open(blog.link, "_blank");
                  }}
                >
                  <img alt="Emorya" src={require("../assets/blog-1.png")} />
                  <div className="blueSubHeading">
                    {formatDate(new Date(blog.pubDate))}
                  </div>
                  <div className="blueSubHeading">{blog.categories}</div>
                  <div className="text">{blog.title}</div>
                </div>
              );
            })}
          </div>

          <div
            className="col-sm-12 mobileTeam"
            style={{
              textAlign: "center",
              paddingTop: 50,
            }}
          >
            <Swiper
              ref={blogSwiperRef}
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={50}
              slidesPerView={1}
              scrollbar={{ draggable: true }}
            >
              {blogs.map((blog) => {
                return (
                  <SwiperSlide key={blog.image}>
                    <div
                      className="blogBox"
                      onClick={() => {
                        window.open(blog.link, "_blank");
                      }}
                    >
                      <img alt="Emorya" src={require("../assets/blog-1.png")} />

                      <div className="blueSubHeading">
                        {formatDate(new Date(blog.pubDate))}
                      </div>
                      <div className="blueSubHeading">{blog.categories}</div>
                      <div className="text">{blog.title}</div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            <div
              style={{
                textAlign: "right",
                padding: 20,
                fontSize: 20,
                color: "#41faa4",
                width: "100%",
              }}
              onClick={() => {
                blogSwiperRef.current.swiper.slideNext();
              }}
            >
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
